import { uploadProcess } from './upload.process.js';
import { base64Upload, fileUpload } from './base64Upload.js';
import YxpUpload from './upload.vue';
import UploadResume from './uploadResume.vue';
import uploadAliResume from './uploadAliResume.vue';
import uploadTencentResume from './uploadTencentResume.vue';
import uploadList from './uploadList.vue';
// import YxpUploadAvatar from './avatar.vue';

YxpUpload.install = function () {
    window.Vue.component(YxpUpload.name, YxpUpload);
    window.Vue.component(UploadResume.name, UploadResume);
    window.Vue.component(uploadAliResume.name, uploadAliResume);
    window.Vue.component(uploadList.name, uploadList);
    window.Vue.component(uploadTencentResume.name, uploadTencentResume);
    // window.Vue.component(YxpUploadAvatar.name, YxpUploadAvatar);
};

window.Vue.use(YxpUpload);
window.Vue.use(UploadResume);
window.Vue.use(uploadAliResume);
window.Vue.use(uploadTencentResume);
// window.Vue.use(YxpUploadAvatar);

export default { uploadProcess, base64Upload, fileUpload };
